import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./cookies.scss";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const decided = localStorage.getItem("cookiesAccepted");
    if (!decided) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem("cookiesAccepted", "true");
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem("cookiesAccepted", "false");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="mz-cookie">
      <p className="mz-cookie__label">COOKIES</p>
      <p className="mz-cookie__body">
        We use cookies to understand how the site is used and to improve your experience. Read our{" "}
        <Link to="/cookies">Cookie Policy</Link> for details.
      </p>
      <div className="mz-cookie__actions">
        <button type="button" className="mz-btn mz-btn--outline" onClick={decline}>
          Decline
        </button>
        <button type="button" className="mz-btn mz-btn--dark" onClick={accept}>
          Accept all
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
